/* NEW: UI_REVAMP */
import { useEffect, useState } from 'react';
import { getDefaultTransactionDateRange } from '../../history/filter/historyFilterConstants';

export const useTransactionFilterState = ({
	isOpen,
	ticketStatus,
	selected,
	startDate,
	endDate,
}) => {
	const [childStatus, setChildStatus] = useState(ticketStatus);
	const [childDateRange, setChildDateRange] = useState(
		getDefaultTransactionDateRange({ selected, startDate, endDate }),
	);
	const [draftDateRange, setDraftDateRange] = useState(
		getDefaultTransactionDateRange({ selected, startDate, endDate }),
	);
	const [isCalendarView, setIsCalendarView] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setChildStatus(ticketStatus);
			const nextDateRange = getDefaultTransactionDateRange({ selected, startDate, endDate });
			setChildDateRange(nextDateRange);
			setDraftDateRange(nextDateRange);
			setIsCalendarView(false);
		}
	}, [endDate, isOpen, selected, startDate, ticketStatus]);

	return {
		childStatus,
		setChildStatus,
		childDateRange,
		setChildDateRange,
		draftDateRange,
		setDraftDateRange,
		isCalendarView,
		setIsCalendarView,
	};
};

export const useHistoryFilterState = ({
	isOpen,
	siteFilter,
	ticketStatus,
	selected,
	startDate,
	endDate,
}) => {
	const [childSite, setChildSite] = useState(siteFilter || 'All');
	const [childStatus, setChildStatus] = useState(ticketStatus || 'All');
	const [childDateRange, setChildDateRange] = useState(
		getDefaultTransactionDateRange({ selected, startDate, endDate }),
	);
	const [draftDateRange, setDraftDateRange] = useState(
		getDefaultTransactionDateRange({ selected, startDate, endDate }),
	);
	const [isCalendarView, setIsCalendarView] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setChildSite(siteFilter || 'All');
			setChildStatus(ticketStatus || 'All');
			const nextDateRange = getDefaultTransactionDateRange({ selected, startDate, endDate });
			setChildDateRange(nextDateRange);
			setDraftDateRange(nextDateRange);
			setIsCalendarView(false);
		}
	}, [endDate, isOpen, selected, siteFilter, startDate, ticketStatus]);

	return {
		childSite,
		setChildSite,
		childStatus,
		setChildStatus,
		childDateRange,
		setChildDateRange,
		draftDateRange,
		setDraftDateRange,
		isCalendarView,
		setIsCalendarView,
	};
};
